import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

function CareerDetails6() {
return (
<> <Header />


  <section className="container" style={{ paddingTop: "120px" }}>
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "20px",
        marginBottom: "40px",
      }}
    >
      <div
        style={{
          width: "300px",
          height: "1px",
          backgroundColor: "#dcdcdc",
        }}
      ></div>

      <p
        style={{
          margin: 0,
          fontSize: "16px",
          color: "#888",
        }}
      >
        <Link
          to="/"
          style={{
            color: "#111",
            textDecoration: "none",
          }}
        >
          Home
        </Link>

        {" / "}

        <Link
          to="/careers"
          style={{
            color: "#111",
            textDecoration: "none",
          }}
        >
          Careers
        </Link>

        {" / "}
        Senior Copywriter
      </p>
    </div>

    <h1
      style={{
        textAlign: "center",
        fontSize: "64px",
        lineHeight: "1.1",
        marginBottom: "80px",
      }}
    >
      <span style={{ fontWeight: "300" }}>
        Senior
      </span>{" "}
      <span style={{ fontWeight: "600" }}>
        Copywriter
      </span>
    </h1>

    <div style={{ maxWidth: "720px", margin: "0 auto" }}>

      <p style={{ marginBottom: "15px", fontSize: "16px" }}>
        <strong>Position:</strong> Senior Copywriter
      </p>

      <p style={{ marginBottom: "15px", fontSize: "16px" }}>
        <strong>Job ID:</strong> BNWJB20260125
      </p>

      <p style={{ marginBottom: "15px", fontSize: "16px" }}>
        <strong>Employment Type:</strong> Full Time (Remote)
      </p>

      <p style={{ marginBottom: "40px", fontSize: "16px" }}>
        <strong>Experience:</strong> 6 to 8 Years
      </p>

      <h4 style={{ marginBottom: "25px" }}>
        About the Role
      </h4>

      <p
        style={{
          fontSize: "16px",
          lineHeight: "1.8",
          color: "#777",
          marginBottom: "40px",
        }}
      >
        We are looking for a strategic, detail-oriented, and idea-driven Senior Copywriter with 5–8 years of experience to lead compelling storytelling across digital and offline platforms. The ideal candidate is a conceptual thinker who can transform business objectives into persuasive brand narratives. You will collaborate closely with designers, strategists, marketers, and leadership teams to deliver impactful campaigns that build brand equity and drive measurable results.
      </p>

      <h4 style={{ marginBottom: "25px" }}>
        Key Responsibilities
      </h4>

      <ul
        style={{
          color: "#777",
          fontSize: "16px",
          lineHeight: "2",
          marginBottom: "40px",
        }}
      >
        <li>Develop high-quality, engaging, and conversion-driven copy for websites, digital campaigns, social media, print collateral, presentations, video scripts, email marketing, and advertising campaigns.</li>
        <li>Lead conceptualization and execution of integrated campaign ideas from ideation to delivery.</li>
        <li>Translate brand strategy and positioning into clear, consistent messaging across all touchpoints.</li>
        <li>Craft taglines, brand stories, manifesto statements, product descriptions, and long-form content.</li>
        <li>Work closely with art directors and designers to ensure cohesive storytelling and visual alignment.</li>
        <li>Mentor and guide junior copywriters, providing constructive feedback and ensuring quality standards.</li>
        <li>Participate in client meetings, presentations, and brainstorming sessions.</li>
        <li>Maintain brand voice consistency while adapting tone for diverse audiences and platforms.</li>
        <li>Conduct research to understand industry trends, consumer behavior, and competitive landscapes.</li>
        <li>Optimize digital copy for SEO and performance metrics where required.</li>
      </ul>

      <h4 style={{ marginBottom: "25px" }}>
        Required Skills & Qualifications
      </h4>

      <ul
        style={{
          color: "#777",
          fontSize: "16px",
          lineHeight: "2",
          marginBottom: "40px",
        }}
      >
        <li>6–8 years of proven experience in copywriting, preferably within an advertising agency, creative studio, or marketing environment.</li>
        <li>Strong portfolio demonstrating expertise across brand campaigns, digital marketing, and content strategy.</li>
        <li>Exceptional command of English with strong grammar, storytelling, and editing skills.</li>
        <li>Ability to think conceptually and secure creative ideas.</li>
        <li>Strong understanding of branding, tone of voice development, and content strategy.</li>
        <li>Experience in writing for digital-first platforms including social media, web, and performance marketing.</li>
        <li>Familiarity with SEO principles and content optimization tools is an advantage.</li>
        <li>Excellent presentation and communication skills.</li>
        <li>Ability to multitask, prioritize, and manage multiple projects simultaneously.</li>
      </ul>

      <h4 style={{ marginBottom: "25px" }}>
        Preferred Attributes
      </h4>

      <ul
        style={{
          color: "#777",
          fontSize: "16px",
          lineHeight: "2",
          marginBottom: "40px",
        }}
      >
        <li>Strategic thinker with a problem-solving mindset.</li>
        <li>Detail-oriented yet capable of seeing the bigger brand picture.</li>
        <li>Collaborative team player with leadership qualities.</li>
        <li>Passionate about trends in marketing, advertising, and consumer culture.</li>
        <li>Adaptable to fast-paced, evolving environments.</li>
      </ul>

<hr
  style={{
    border: "none",
    borderTop: "1px solid #ddd",
    marginTop: "60px",
    marginBottom: "30px",
  }}
/>

<div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "20px",
    marginBottom: "50px",
  }}
>
  <Link
    to="/apply-job"
    style={{
      textDecoration: "none",
      color: "#111",
      fontSize: "16px",
      fontWeight: "500",
    }}
  >
    Apply
  </Link>

  <Link
    to="/apply-job"
    style={{
      width: "48px",
      height: "48px",
      borderRadius: "50%",
      background: "#e5e5e5",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textDecoration: "none",
      color: "#111",
      fontSize: "22px",
    }}
  >
    →
  </Link>
</div>

    </div>
  </section>

  <Footer />
</>


);
}

export default CareerDetails6;